/* BRS: keep the page still when a variant is chosen.

   Clicking a <label> for a visually hidden radio makes the browser focus that radio, and the browser
   then scrolls it into view. Firefox does this even when the label is already on screen, which yanks
   the shopper hundreds of pixels and drags the sticky header down with it. (Chrome is less eager,
   so this only shows up in some browsers.)

   Rather than let the label do it natively, we set the radio ourselves and fire the change event the
   theme listens for. The variant still updates; the page does not move. Keyboard use is untouched:
   the radios are still focusable and arrow keys still work. */
(() => {
  const SELECTOR = '.brs-packages__card, .product-form__input--pill label, .product-form__input--swatch label';

  document.addEventListener(
    'click',
    (event) => {
      const label = event.target.closest(SELECTOR);
      if (!label) return;
      const id = label.getAttribute('for') || (label.control && label.control.id);
      const input = id ? document.getElementById(id) : null;
      if (!input || input.type !== 'radio' || input.disabled) return;

      // never let the label move focus (and therefore the page)
      event.preventDefault();
      if (input.checked) return;

      const y = window.scrollY;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      // belt and braces: if anything else nudges the page during the re-render, put it back
      const hold = () => { if (Math.abs(window.scrollY - y) > 2) window.scrollTo({ top: y, behavior: 'instant' }); };
      requestAnimationFrame(hold);
      setTimeout(hold, 80);
      setTimeout(hold, 300);
    },
    true
  );
})();
